import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, throwError} from 'rxjs';
import {Recommendations} from '../../shared/models/recommendations.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class RecommendationsService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getRecommendations(): Observable<Recommendations> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const url = this.apiConfigService.getRecommendationsUrl(apartmentId);
    const key = `RecommendationsService:GET:${url}`;

    return this.cache.getOrSet<Recommendations>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<Recommendations>(url)
    );
  }
}
